import { CustomerType } from "@origin-digital/platform-enums";
import { IMcAppType, NavFlow, Tab } from "../mcApp.types";

export const offers: IMcAppType = {
  name: "offers_SAP",
  path: "/my-account/offers",
  description: "My offers",
  navFlow: NavFlow.FOCUS,
  title: "My offers",
  parent: Tab.MORE,
  conditions: {
    intent: "offers",
    customerType: CustomerType.sap,
  },
};
